import { Routes, Route, Navigate } from 'react-router-dom';
import ReviewPageFinal from './components/ReviewPageFinal';
import ContentPreview from './components/ContentPreview';
import ContentEditor from './components/ContentEditor';
import AssetCreation from './components/AssetCreation';
import AssetManagement from './components/AssetManagement';
import Login from './components/Login';
import DashboardLayout from './components/Dashboard/LayoutNew';
import DashboardOverview from './components/Dashboard/Overview';
import ClientsManagement from './components/Dashboard/clients';
import ClientDetail from './components/Dashboard/ClientDetail';
import ContentManagement from './components/Dashboard/ContentManagement';
import TeamManagement from './components/Dashboard/TeamManagement';
import SimplePlanBuilder from './components/Dashboard/SimplePlanBuilder';
import SimplePlanView from './components/Dashboard/SimplePlanView';
import PostTypesManager from './components/Dashboard/PostTypesManager';
import WorkflowDashboard from './components/Dashboard/WorkflowDashboard';
import ProjectsDashboard from './components/Dashboard/ProjectsDashboard';
import ProjectsWithClients from './components/Dashboard/ProjectsWithClients';
import ProjectDetail from './components/Dashboard/ProjectDetail';
import OrganizationsManagement from './components/Dashboard/OrganizationsManagement';
import ContactsManagement from './components/Dashboard/ContactsManagement';
import BrandsManagement from './components/Dashboard/BrandsManagement';
import SocialContentManagement from './components/Dashboard/SocialContentManagement';
import WebsiteManagement from './components/Dashboard/WebsiteManagement';
import SEOManagement from './components/Dashboard/SEOManagement';
import AdsManagement from './components/Dashboard/AdsManagement';
import EmailContentManagement from './components/Dashboard/EmailContentManagement';
import EmailManagement from './components/Dashboard/EmailManagement';
import DesignManagement from './components/Dashboard/DesignManagement';
import WorkflowDashboard from './components/Dashboard/WorkflowDashboard';
import IntegrationsManagement from './components/Dashboard/IntegrationsManagement';

// Protected Route Wrapper
function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const token = localStorage.getItem('token');
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}

function App() {
  return (
    <Routes>
      {/* Login Route */}
      <Route path="/login" element={<Login />} />

      {/* Dashboard Routes - Protected */}
      <Route path="/dashboard" element={
        <ProtectedRoute>
          <DashboardLayout />
        </ProtectedRoute>
      }>
        <Route index element={<DashboardOverview />} />

        {/* Organizations & Clients */}
        <Route path="organizations" element={<OrganizationsManagement />} />
        <Route path="contacts" element={<ContactsManagement />} />
        <Route path="brands" element={<BrandsManagement />} />

        {/* Legacy client routes - keep for existing links */}
        <Route path="clients" element={<ClientsManagement />} />
        <Route path="clients/:clientId" element={<ClientDetail />} />

        {/* Projects & Assets */}
        <Route path="projects" element={<ProjectsWithClients />} />
        <Route path="projects/:id" element={<ProjectDetail />} />
        <Route path="assets" element={<AssetManagement />} />
        <Route path="assets/create" element={<AssetCreation />} />
        <Route path="assets/:id/edit" element={<AssetCreation />} />

        {/* Content */}
        <Route path="content/:id/preview" element={<ContentPreview />} />
        <Route path="content/:id/edit" element={<ContentEditor />} />
        <Route path="social" element={<SocialContentManagement />} />
        <Route path="websites" element={<WebsiteManagement />} />
        <Route path="seo" element={<SEOManagement />} />
        <Route path="ads" element={<AdsManagement />} />
        <Route path="emails" element={<EmailManagement />} />
        <Route path="design" element={<DesignManagement />} />
        <Route path="workflow" element={<WorkflowDashboard />} />

        {/* Legacy routes - redirect to new pages */}
        <Route path="websites-seo" element={<Navigate to="/dashboard/websites" replace />} />

        {/* Settings */}
        <Route path="integrations" element={<IntegrationsManagement />} />

        {/* Legacy routes */}
        <Route path="plans" element={<ContentManagement />} />
        <Route path="plans/simple/new" element={<SimplePlanBuilder />} />
        <Route path="plans/simple/:id" element={<SimplePlanView />} />
        <Route path="plans/simple/:id/edit" element={<SimplePlanBuilder />} />
        <Route path="content" element={<ContentManagement />} />
        <Route path="team" element={<TeamManagement />} />
        <Route path="post-types" element={<PostTypesManager />} />
        <Route path="feedback" element={<div className="p-8">Feedback Management (Coming Soon)</div>} />
      </Route>

      {/* Review System Routes */}
      {/* URL structure: /{code}/review/{plan_id} - where code can be AM or Client review code */}
      <Route path=":code/review/:planId" element={<ReviewPageFinal />} />
      {/* Legacy route support */}
      <Route path="review/:code" element={<ReviewPageFinal />} />

      {/* Default/Home route - redirect to dashboard */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />

      {/* Catch all - redirect to dashboard */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default App;